<template>
    <div>
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mb-3">
                            <div class="col-12">
                                <div class="row">
                                    <div class="col-md-3">
                                        <b-form-input
                                            v-model="filter"
                                            class="form-control"
                                            type="search"
                                            :placeholder="$t('label.search')"
                                            v-on:change="searchListing"
                                            @keyup.enter="searchListing"
                                            autocomplete="off"
                                        />
                                    </div>
                                    <div class="col-md-2">
                                        <b-form-select
                                            v-model="isActive"
                                            :options="statusDdl"
                                            @change="searchListing"
                                        />
                                    </div>
                                    <div class="col-md-5"></div>
                                    <div class="col-md-2">
                                        <b-button
                                            class="btn-info col-12"
                                            v-on:click="openForm()"
                                        >
                                            {{ $t('label.createX', []) }}
                                        </b-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="table-responsive mb-0">
                            <b-table
                                v-if="status.list"
                                :items="tableRows"
                                :fields="fields"
                                :per-page="perPage"
                                responsive="sm"
                            >
                                <template #cell(status)="data">
                                    <b-badge :variant="data.item.isActive == 1 ? 'success' : 'secondary'">
                                        {{ data.item.isActive == 1 ? $t('label.active') : $t('label.inactive') }}
                                    </b-badge>
                                </template>
                                <template #cell(actions)="data">
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info"
                                        v-b-tooltip.hover
                                        :title="$t('label.updateX', [])"
                                        @click.stop="openForm(data.item)"
                                    >
                                        <i class="mdi mdi-pencil font-size-18"></i>
                                    </a>
                                    <a
                                        href="javascript:void(0);"
                                        class="text-info ml-1"
                                        v-b-tooltip.hover
                                        :title="data.item.isActive == 0 ? $t('label.restoreX', []) : $t('label.deleteX', [])"
                                        v-on:click="deleteConfirmation(data.item)"
                                    >
                                        <i :class="[`mdi font-size-18 mdi-delete-${data.item.isActive == 0 ? 'restore' : 'outline'}`]"></i>
                                    </a>
                                </template>
                            </b-table>
                            <div v-else class="d-flex justify-content-center align-items-center p-5 m-5">
                                <b-spinner class="m-5" variant="info" role="status"></b-spinner>
                            </div>
                            <b-alert
                                v-if="tableRows.length == 0 && status.list"
                                show
                                variant="warning"
                                class="mt-0 text-center"
                            >
                                <i class="mdi mdi-alert-circle-outline"></i> {{ $t('message.noResultsFound') }}
                            </b-alert>
                            <div v-if="tableRows.length > 0" class="d-flex justify-content-end mt-3">
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="totalRows"
                                    :per-page="perPage"
                                    @change="pageNavigation"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <b-modal
            id="sport-club-board-type-form"
            :title="$t(boardType.uuid ? 'label.updateX' : 'label.createX', [$t('module.sportClubBoardType')])"
            @hidden="closeForm"
            hide-footer
            hide-header-close
            centered
        >
            <b-container fluid>
                <SportClubBoardTypeForm
                    v-if="formVisible"
                    :sportClubBoardTypeUUID="boardType.uuid"
                    :searchCriteria="searchCriteria"
                    @done="closeForm"
                />
            </b-container>
        </b-modal>
        <b-modal
            id="sport-club-board-type-delete"
            :title="boardType.isActive == 0 ? $t('label.restoreX', []) : $t('label.deleteX', [])"
            @hidden="closeForm"
            hide-header-close
        >
            <p class="my-4">{{ boardType.isActive == 0 ? $t('message.restoreConfirmation') : $t('message.deleteConfirmation') }}</p>
            <template #modal-footer>
                <b-button variant="danger" class="col-2" @click="$bvModal.hide('sport-club-board-type-delete')">
                    {{ $t('label.cancel') }}
                </b-button>
                <b-button
                    variant="info"
                    class="ml-2 col-2"
                    v-on:click="requestDelete"
                    :disabled="!status.save"
                >
                    {{ boardType.isActive == 0 ? $t('label.restoreX', []) : $t('label.deleteX', []) }}
                </b-button>
            </template>
        </b-modal>
    </div>
</template>
<script>
import i18n from '@/i18n';
import { SHARED } from '@/constants';
import { ddlHelper } from '@/utils';
import { mapState } from 'vuex';
import { sportClubBoardTypeMethods } from '@/state/api';
import { SPORT_CLUB_BOARD_TYPE_MODULE } from '@/state/api/sportClubBoardType.state';
import SportClubBoardTypeForm from '@/views/pages/admin/sportClubBoardType/sportClubBoardTypeForm';

export default {
    components: { SportClubBoardTypeForm },
    created() {
        this.initSearchCriteria();
    },
    data() {
        return {
            filter: '',
            currentPage: 1,
            perPage: SHARED.DEFAULT_PAGE_SIZE,
            statusDdl: ddlHelper.getActivationStatus(true),
            isActive: 1,
            fields: [
                { key: 'name', label: i18n.t('label.name'), sortable: true, class: 'text-nowrap' },
                { key: 'status', label: i18n.t('label.status'), sortable: true, class: 'text-nowrap' },
                { key: 'actions', label: i18n.t('label.action'), sortable: false, class: 'text-nowrap' },
            ],
            boardType: {
                uuid: '',
                isActive: false,
            },
            formVisible: false,
            searchCriteria: {},
        };
    },
    methods: {
        ...sportClubBoardTypeMethods,
        initSearchCriteria() {
            this.searchCriteria = {
                pageNumber: SHARED.DEFAULT_PAGE_NUMBER,
                pageSize: SHARED.DEFAULT_PAGE_SIZE,
                isActive: (typeof this.isActive === 'object' && this.isActive !== null) ? this.isActive.value : this.isActive,
                searchArray: [],
                sortBy: 'created_at',
                orderBy: 'desc',
            };
            this.getBoardTypeList(this.searchCriteria);
        },
        getBoardTypeList(filter) {
            this.searchCriteria = filter;
            this.getAllSportClubBoardType({ filter });
        },
        pageNavigation(pageNumber) {
            this.searchCriteria.pageNumber = pageNumber;
            this.getBoardTypeList(this.searchCriteria);
        },
        searchListing() {
            this.searchCriteria.pageNumber = SHARED.DEFAULT_PAGE_NUMBER;
            this.searchCriteria.searchArray = this.filter ? [this.filter] : [];
            this.searchCriteria.isActive = (typeof this.isActive === 'object' && this.isActive !== null) ? this.isActive.value : this.isActive;
            this.currentPage = 1;
            this.getBoardTypeList(this.searchCriteria);
        },
        deleteConfirmation(data) {
            this.boardType = {
                uuid: data.uuid,
                isActive: data.isActive,
            };
            this.$bvModal.show('sport-club-board-type-delete');
        },
        async requestDelete() {
            const data = {
                uuid: this.boardType.uuid,
                isActive: this.boardType.isActive == 0 ? 1 : 0,
            };
            const result = await this.updateSportClubBoardTypeStatus({ data, filter: this.searchCriteria });
            if (result) this.$bvModal.hide('sport-club-board-type-delete');
        },
        openForm(data) {
            this.boardType = {
                uuid: data?.uuid || '',
                isActive: data?.isActive || false,
            };
            this.formVisible = true;
            this.$nextTick(() => this.$bvModal.show('sport-club-board-type-form'));
        },
        closeForm() {
            this.boardType = { uuid: '', isActive: false };
            this.formVisible = false;
            this.$bvModal.hide('sport-club-board-type-form');
        },
    },
    computed: {
        ...mapState(SPORT_CLUB_BOARD_TYPE_MODULE, ['status']),
        tableRows() {
            return this.$store.state.api.sportClubBoardType.list.data || [];
        },
        totalRows() {
            return this.$store.state.api.sportClubBoardType.list.pagination.total || 0;
        },
    },
};
</script>
